import { API_BASE } from '../../services/api/config'

/**
 * Sends a base64 PNG image to the backend AI-enhance proxy, which forwards it to
 * Gemini using a server-side key. The API key is never exposed to the browser.
 * @param {string} base64Image - base64 encoded image (no data: prefix)
 * @param {string} mimeType
 * @returns {Promise<{ blob: Blob, text: string | null }>}
 */
export async function enhanceImage(base64Image, mimeType = 'image/png') {
  const response = await fetch(`${API_BASE}/api/v2/enhance`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ image: base64Image, mimeType }),
  })

  const data = await response.json().catch(() => null)
  if (!response.ok || !data?.success) {
    throw new Error(data?.error || `AI enhancement request failed (${response.status})`)
  }
  if (!data.image) throw new Error('AI enhancement did not return an image')

  const bytes = Uint8Array.from(atob(data.image), (c) => c.charCodeAt(0))
  const blob = new Blob([bytes], { type: data.mimeType || 'image/png' })
  return { blob, text: data.text ?? null }
}
